import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import { dynamicDataAttribute, toOneString } from 'helpers/utils'
import Theme from 'components/common/Theme/Theme'
import Mixin from 'components/common/Mixin'
import Icon from 'components/common/Icon/Icon'
import { PASSWORD_HINT_ID } from 'constant'

const Rule = ({ active = true, isValid, label = '', children }) =>
  <RuleWrapper { ...dynamicDataAttribute('rule', toOneString(label)) }>
    <Icon
      asset={ active ? 'icon-rule-default' : 'icon-rule-error' }
      alternative="icon-rule-success"
      condition={ isValid }
      width={ 16 }
      height={ 16 } />
    <RuleItem active={ active } isValid={ isValid } id={ PASSWORD_HINT_ID } data-at-rule-text>{ children }</RuleItem>
  </RuleWrapper>

Rule.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.node,
  isValid: PropTypes.bool,
  label: PropTypes.string
}

export default Rule

const RuleWrapper = styled.div`
  margin-bottom: 6px;
  display: flex;
`

const RuleItem = styled.div`
  display: inline-block;
  margin-left: 8px;
  color: ${Theme.colors.dark_grey};
  ${Mixin.font.GothamBook(12)}
  ${props => props.isValid && css`
    color: ${Theme.colors.green};
    font-weight: 700;
  `}
  ${props => !props.active && !props.isValid && css`
    color: ${Theme.colors.bright_red_new};
    font-weight: 700;
  `}
`
